import type { Lesson, LabStep } from '../types';
import { m0 } from './m0';
import { m1 } from './m1';
import { m2 } from './m2';
import { m3 } from './m3';
import { m4 } from './m4';
import { m5 } from './m5';
import { m6 } from './m6';
import { m7 } from './m7';
import { m8 } from './m8';

/** Bump when lesson or gate content changes in a way that affects stored progress. */
export const CONTENT_VERSION = '2026.09.1';

export const LESSONS: Lesson[] = [m0, m1, m2, m3, m4, m5, m6, m7, m8];

export const LESSON_BY_ID: Record<string, Lesson> = Object.fromEntries(LESSONS.map((l) => [l.id, l]));

export const LAB_STEPS: Record<string, { lesson: Lesson; step: LabStep }> = Object.fromEntries(
  LESSONS.flatMap((lesson) => lesson.lab.steps.map((step) => [step.id, { lesson, step }])),
);
